import { FieldValidator } from 'final-form'
import { FaqTypeEnum } from '__generatedTypes__/globalTypes'
import { FaqListItem } from './types'

export const FAQ_HIGHER_SCORE_TYPE_ERROR = 'Only one FAQ item can have the Higher Score type.'

export const validateFaqList: FieldValidator<FaqListItem[]> = (list) => {
  if (!list?.length) {
    return undefined
  }

  const higherScoreCount = list.filter((item) => item.type?.id === FaqTypeEnum.HigherScore).length

  if (higherScoreCount <= 1) {
    return undefined
  }

  return list.map((item) => (item.type?.id === FaqTypeEnum.HigherScore ? FAQ_HIGHER_SCORE_TYPE_ERROR : undefined))
}
